/**
 * deliveryOffers: how the web reads and names a free-delivery offer the
 * server applied to a quote (first order, or an invite credit). The server
 * decides the offer and the amount; this only reads its answer, labels it the
 * same way on every surface, and names it in the growth events.
 *
 * Quote shape: offer = { kind, originalFee, waivedAmount } | null, with the
 * quote's own `fee` already net of the waiver.
 */

export const DELIVERY_OFFER_LABELS = {
  FIRST_ORDER_FREE_DELIVERY: "Free on your first order",
  REFERRAL_FREE_DELIVERY: "Free with your invite",
};

/* The growth-event names for each kind (shared with the apps). */
export const DELIVERY_OFFER_EVENT_KEYS = {
  FIRST_ORDER_FREE_DELIVERY: "first_order_free_delivery",
  REFERRAL_FREE_DELIVERY: "referral_free_delivery",
};

export const deliveryOfferOf = (quote) => {
  const offer = quote?.offer;
  if (!offer || !(Number(offer.waivedAmount) > 0)) return null;
  return {
    kind: String(offer.kind || ""),
    originalFee: Number(offer.originalFee) || 0,
    waivedAmount: Number(offer.waivedAmount) || 0,
  };
};

export const deliveryOfferLabel = (offer) =>
  (offer && DELIVERY_OFFER_LABELS[offer.kind]) || "Offer applied";

export const deliveryOfferEventKey = (offer) =>
  (offer && DELIVERY_OFFER_EVENT_KEYS[offer.kind]) || "";
